export default __webpack_public_path__ + "static/media/Cape of Reprisal.d618b0bb.jpg";